import React, { Fragment } from "react";
import "./AuthorRegister.css";
import MaskedInput from "react-maskedinput";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { postAuthor } from "../../services/Author";
import { Creators as LoaderActions } from "../../store/ducks/loader";
import Modal from "../Modal";
import ModalContentMessage from "../ModalContentMessage";
class AuthorRegister extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0,0);
    this.state = {
      openModal: false,
      sex: "",
      name: "",
      lastName: "",
      email: "",
      celPhone: "",
      phone: "",
      operator: "",
      address: {
        postCode: "",
        street: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
        complement: ""
      }
    };
    this.handleSex = this.handleSex.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleSex(e) {
    this.setState({ sex: e.target.value });
  }

  cleanForm() {
    this.setState({
      name: "",
      lastName: "",
      email: "",
      celPhone: "",
      phone: "",
      operator: ""
    });
    const state = this.state;
    state.address.postCode = "";
    state.address.street = "";
    state.address.number = "";
    state.address.neighborhood = "";
    state.address.state = "";
    state.address.city = "";
    state.address.complement = "";
    this.setState(state);
  }

  async handleFormSubmit(e) {
    e.preventDefault();
    const { isLoading } = this.props;
    isLoading(true);
    const {
      name,
      lastName,
      email,
      celPhone,
      phone,
      operator,
      address
    } = this.state;
    const data = {
      name,
      lastName,
      email,
      celPhone,
      phone,
      operator,
      address
    };
    try {
      await postAuthor(data);
      isLoading(false);
      this.setState({ openModal: true });
      this.cleanForm();
    } catch (Error) {
      alert("Aconteceu um erro!");
    }
  }

  handleCloseModal() {
    this.setState({ openModal: false });
  }

  render() {
    const {
      openModal,
      sex,
      name,
      lastName,
      email,
      celPhone,
      phone,
      operator
    } = this.state;

    const {
      postCode,
      street,
      number,
      neighborhood,
      city,
      state,
      complement
    } = this.state.address;

    return (
      <Fragment>
        <div id="AuthorRegister" className="container mt-5">
          <h3 className="authorRegister-default-color"> CADASTRO DO AUTOR </h3>
          <div className="container">
            <h5 className="autorRegister-formtitle">Dados Pessoais</h5>
            <form onSubmit={this.handleFormSubmit}>
              <div className="row">
                <div className="col-xl-12">
                  <label className="bookregister-label">SEXO</label>
                  <div className="radio-buttons">
                    <label className="container-label" htmlFor="rd_masc">
                      Masculino
                      <input
                        name="sexo-radio"
                        id="rd_masc"
                        type="radio"
                        value="masculino"
                        checked={sex === "masculino"}
                        onChange={this.handleSex}
                      />
                      <span className="checkmark" />
                    </label>
                    <label className="container-label" htmlFor="rd_fem">
                      Feminino
                      <input
                        name="sexo-radio"
                        id="rd_fem"
                        type="radio"
                        value="feminino"
                        checked={sex === "feminino"}
                        onChange={this.handleSex}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="nome">
                      NOME
                    </label>
                    <input
                      required
                      value={name}
                      onChange={e => this.setState({ name: e.target.value })}
                      type="text"
                      className="form-control author-input"
                      id="nome"
                    />
                  </div>
                </div>
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="sobrenome">
                      SOBRENOME
                    </label>
                    <input
                      value={lastName}
                      onChange={e =>
                        this.setState({ lastName: e.target.value })
                      }
                      type="text"
                      className="form-control author-input"
                      id="sobrenome"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="author-label" htmlFor="email">
                      EMAIL
                    </label>
                    <input
                      required
                      value={email}
                      type="email"
                      className="form-control author-input"
                      id="email"
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="celular">
                      CELULAR
                    </label>
                    <MaskedInput
                      required
                      value={celPhone}
                      mask="(11) 1 1111-1111"
                      className="form-control author-input"
                      id="celular"
                      onChange={e =>
                        this.setState({ celPhone: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-12 col-xl-6">
                  <div className="">
                    <label className="author-label" htmlFor="operadora">
                      OPERADORA
                    </label>
                    <select
                      required
                      value={operator}
                      className="form-control author-input"
                      id="operadora"
                      onChange={e =>
                        this.setState({ operator: e.target.value })
                      }
                    >
                      <option>TIM</option>
                      <option>OI</option>
                      <option>CLARO</option>
                      <option>VIVO</option>
                      <option>OUTRA</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="telefone">
                      TELEFONE
                    </label>
                    <MaskedInput
                      value={phone}
                      mask="(11) 1111-1111"
                      className="form-control author-input"
                      id="telefone"
                      onChange={e =>
                        this.setState({ phone: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <h5 className="autorRegister-formtitle title-largo">Endereço</h5>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="cep">
                      CEP
                    </label>
                    <MaskedInput
                      value={postCode}
                      mask=" 11111-111"
                      className="form-control author-input"
                      id="cep"
                      onChange={e => {
                        const state = this.state;
                        state.address.postCode = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-9">
                  <div className="form-group">
                    <label className="author-label" htmlFor="logradouro">
                      LOGRADOURO
                    </label>
                    <input
                      required
                      value={street}
                      type="text"
                      className="form-control author-input"
                      id="logradouro"
                      onChange={e => {
                        const state = this.state;
                        state.address.street = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label className="author-label" htmlFor="numero">
                      NÚMERO
                    </label>
                    <input
                      required
                      value={number}
                      type="number"
                      className="form-control author-input"
                      id="numero"
                      onChange={e => {
                        const state = this.state;
                        state.address.number = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="bairro">
                      BAIRRO
                    </label>
                    <input
                      required
                      value={neighborhood}
                      type="text"
                      className="form-control author-input"
                      id="bairro"
                      onChange={e => {
                        const state = this.state;
                        state.address.neighborhood = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="cidade">
                      CIDADE
                    </label>
                    <input
                      required
                      value={city}
                      type="text"
                      className="form-control author-input"
                      id="cidade"
                      onChange={e => {
                        const state = this.state;
                        state.address.city = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="estado">
                      ESTADO
                    </label>
                    <input
                      required
                      value={state}
                      type="text"
                      className="form-control author-input"
                      id="estado"
                      onChange={e => {
                        const state = this.state;
                        state.address.state = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-xl-6">
                  <div className="form-group">
                    <label className="author-label" htmlFor="complemento">
                      COMPLEMENTO
                    </label>
                    <input
                      value={complement}
                      type="text"
                      className="form-control author-input"
                      id="COMPLEMENTO"
                      onChange={e => {
                        const state = this.state;
                        state.address.complement = e.target.value;
                        this.setState(state);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="button-push mt-4 mb-4">
                <button type="submit">Enviar</button>
              </div>
            </form>
          </div>
        </div>
        <Modal open={openModal} onClose={this.handleCloseModal}>
          <ModalContentMessage
            onCLickButton={this.handleCloseModal}
            message="Cadastro efetuado com sucesso!"
          />
        </Modal>
      </Fragment>
    );
  }
}
const mapDispatchToProps = dispatch =>
  bindActionCreators(LoaderActions, dispatch);
export default connect(
  null,
  mapDispatchToProps
)(AuthorRegister);



// WEBPACK FOOTER //
// ./src/components/AuthorRegister/AuthorRegister.js